import { StoreState as CombinedExchangeSliceState } from "./index";

export const getExchangeId = (state: CombinedExchangeSliceState) =>
  state.exchange.exchangeId;

export function getExchanges(
  state: CombinedExchangeSliceState
): CombinedExchangeSliceState["exchange"]["exchanges"] {
  return state.exchange.exchanges;
}

export function getIsLoadingExchanges(
  state: CombinedExchangeSliceState
): CombinedExchangeSliceState["isLoadingExchanges"] {
  return state.isLoadingExchanges;
}

export const getIsOrdergrooveSubscriptionActive = (
  state: CombinedExchangeSliceState
): boolean | undefined => state.exchange.ordergrooveSubscriptionActive;
